import React from 'react';
import cn from 'clsx';

import Tooltip from '../../library/tooltip/tooltip';
import {
  SnowflakeRegularIcon,
  SunBrightSolidIcon
} from '../../shared/icons/icons';

import styles from './winter-tire-badge.scss';

interface WinterTireBadgeProps {
  isWinterOnly?: boolean;
}

function WinterTireBadge(props: WinterTireBadgeProps) {
  const { isWinterOnly } = props;

  return (
    <Tooltip
      className="winter-tire-badge"
      content={isWinterOnly ? 'Winter Tire' : 'Multi-Season Tire'}
      hoverOver
      render={
        <>
          {isWinterOnly && (
            <div
              className={cn(
                styles['winter-only'],
                'winter-tire-badge__winter-only'
              )}
            >
              <SnowflakeRegularIcon />
            </div>
          )}

          {!isWinterOnly && (
            <div
              className={cn(
                styles['winter-capapble'],
                'winter-tire-badge__winter-capable'
              )}
            >
              <div
                className={cn(
                  styles['winter-capable-sun'],
                  'winter-tire-badge__winter-capable-sun'
                )}
              >
                <SunBrightSolidIcon />
              </div>
              <div
                className={cn(
                  styles['winter-capable-snow'],
                  'winter-tire-badge__winter-capable-snow'
                )}
              >
                <SnowflakeRegularIcon />
              </div>
            </div>
          )}
        </>
      }
    />
  );
}

export default WinterTireBadge;
